// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JfEOQ","titleCard":"styles_titleCard__6FMJs","subTitleCard":"styles_subTitleCard__PW0Uo","shimmer":"styles_shimmer__4-xXQ"};